import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-update-question',
  templateUrl: './update-question.component.html',
  styleUrls: ['./update-question.component.scss']
})
export class UpdateQuestionComponent implements OnInit {

  @ViewChild('closeAddQuestionAnswerModel') private closeAddQuestionAnswerModel: any;
  @ViewChild('closeEditQuestionAnswerModel') private closeEditQuestionAnswerModel: any;

  showLoader: boolean = false;
  showQuestionAnswer: boolean = false;
  updating = false;
  questionAnswers: any = [];
  deleteQuestionAnswersIds: any = [];
  currentUpdateQuestionAnswer: any;
  currentQuestionId: any;
  orgid = this.globals.orgId;
  selectedQuestionType: any;
  selectedActiveFlag: any;
  selectedRequiredFlag: any;

  updateQuestion = new FormGroup({
    questionDescAr: new FormControl('', [
      Validators.required,
    ]),
    questionDescEn: new FormControl('', [
      Validators.required,
    ]),
    questionType: new FormControl('', [
      Validators.required,
    ]),
    sectionNo: new FormControl('', [
      Validators.required,
    ]),
    activeFlag: new FormControl('', [
      Validators.required,
    ]),
    orderNo: new FormControl('', [
      Validators.required,
    ]),
    requiredFlag: new FormControl('', [
      Validators.required,
    ])
  });

  questionAnswerPopUp = new FormGroup({
    valueDescAr: new FormControl('', [
      Validators.required,
    ]),
    valueDescEn: new FormControl('', [
      Validators.required,
    ]),
    orderNo: new FormControl('', [
      Validators.required,
    ])
  });

  updateQuestionAnswerPopUp = new FormGroup({
    valueDescAr: new FormControl('', [
      Validators.required,
    ]),
    valueDescEn: new FormControl('', [
      Validators.required,
    ]),
    orderNo: new FormControl('', [
      Validators.required,
    ])
  });

  constructor(private admService: AdmService, private toastrService: ToastrService, public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, public translate: TranslateService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.currentQuestionId = params['questionId'] || "";

        if (this.currentQuestionId != "") {
          this.getQuestionById();
        } else {

          this.toastr.warning(this.translate.instant('QUESTION_NOT_FOUND'));
          this.router.navigate(['/admission/questions']);
        }
      });
  }

  getQuestionById() {
    this.showLoader = true;
    this.admService.getQuestionById(this.currentQuestionId)
      .subscribe(
        data => {
          this.updateQuestion.controls.questionDescAr.setValue(data.questionDescAr);
          this.updateQuestion.controls.questionDescEn.setValue(data.questionDescEn);
          this.updateQuestion.controls.questionType.setValue(data.questionType);
          this.selectedQuestionType = data.questionType;
          this.updateQuestion.controls.sectionNo.setValue(data.sectionNo);
          this.updateQuestion.controls.activeFlag.setValue(data.activeFlag);
          this.selectedActiveFlag = data.activeFlag;
          this.updateQuestion.controls.orderNo.setValue(data.orderNo);
          this.updateQuestion.controls.requiredFlag.setValue(data.requiredFlag);
          this.selectedRequiredFlag = data.requiredFlag;

          if (data.questionType == "LIST") {
            this.showQuestionAnswer = true;
            this.getQuestionAnswers();
          } else {
            this.showLoader = false
          }
        },
        error => {
          this.showLoader = false
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_QUESTION'));
        }
      );
  }

  getQuestionAnswers() {
    this.admService.getQuestionAnswers(this.orgid, this.currentQuestionId)
      .subscribe(
        data => {
          this.questionAnswers = data;
          this.showLoader = false;
        },
        error => {
          this.showLoader = false;
          this.toastrService.error(this.translate.instant('CAN_NOT_ADD_ANSWERS'));
        }
      );
  }

  updateQuestionSubmit() {
    if (this.updateQuestion.valid) {
      this.updating = true;
      let questionDescAr = this.updateQuestion.controls.questionDescAr.value;
      let questionDescEn = this.updateQuestion.controls.questionDescEn.value;
      // let questionType = this.updateQuestion.controls.questionType.value;
      let questionType = this.selectedQuestionType;
      let sectionNo = this.updateQuestion.controls.sectionNo.value;
      let orderNo = this.updateQuestion.controls.orderNo.value;
      let activeFlag = this.updateQuestion.controls.activeFlag.value;
      let requiredFlag = this.updateQuestion.controls.requiredFlag.value;

      if (questionType != "LIST" || (questionType == "LIST" && this.questionAnswers.length >= 2)) {
        this.admService.updateQuestion(this.currentQuestionId, this.orgid, questionDescAr, questionDescEn, questionType, sectionNo, orderNo, activeFlag, requiredFlag)
          .subscribe(
            data => {
              if (questionType == "LIST") {
                this.updatingQuestionAnswerToBe(this.currentQuestionId);
              } else {
                this.router.navigate(['/admission/questions']);
                this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
                this.updating = false
              }
            },
            error => {
              this.updating = false
              this.toastrService.warning(this.translate.instant('CAN_NOT_CREATE'));
            }
          );
      } else {
        this.toastrService.warning(this.translate.instant('PLEASE_ENTER_QUESTION_ANSWERS'));
        this.updateQuestion.markAllAsTouched();
        this.updateQuestion.markAsDirty();
      }
    }
    else {
      this.toastrService.warning(this.translate.instant('PLEASE_ENTER_REQUIRE_FIEDLS'));
      this.updateQuestion.markAllAsTouched();
      this.updateQuestion.markAsDirty();
    }
  }

  updateQuestionChange() { }
  changeQuestionType() {
    let questionType = this.updateQuestion.controls.questionType.value;
    if (questionType == "LIST") {
      this.showQuestionAnswer = true;
    } else {
      this.showQuestionAnswer = false;
    }
  }
  clearAddQuestionAnswerForm() {
    this.questionAnswerPopUp.reset();
  }
  addQuestionAnswer() {
    if (this.questionAnswerPopUp.valid) {
      let questionAnswer = {
        "valueDescAr": this.questionAnswerPopUp.controls.valueDescAr.value,
        "valueDescEn": this.questionAnswerPopUp.controls.valueDescEn.value,
        "orderNo": this.questionAnswerPopUp.controls.orderNo.value
      };
      this.questionAnswers.push(questionAnswer);
      this.closeAddQuestionAnswerModel.nativeElement.click();
      this.questionAnswerPopUp.reset();

    } else {
      this.toastrService.warning(this.translate.instant('PLEASE_ENTER_REQUIRE_FIEDLS'));
      this.questionAnswerPopUp.markAllAsTouched();
      this.questionAnswerPopUp.markAsDirty();
    }
  }

  editQuestionAnswer(index: number) {
    if (typeof this.questionAnswers[index] != 'undefined') {
      this.currentUpdateQuestionAnswer = index;
      let valueDescAr = this.questionAnswers[index]?.valueDescAr;
      let valueDescEn = this.questionAnswers[index]?.valueDescEn;
      let orderNo = this.questionAnswers[index]?.orderNo;
      this.updateQuestionAnswerPopUp.controls.valueDescAr.setValue(valueDescAr);
      this.updateQuestionAnswerPopUp.controls.valueDescEn.setValue(valueDescEn);
      this.updateQuestionAnswerPopUp.controls.orderNo.setValue(orderNo);
    } else {
      this.currentUpdateQuestionAnswer = null;
      this.toastrService.warning(this.translate.instant('QUESTION_ANSWER_NOT_EXIST'));
    }

  }

  updateQuestionAnswerSubmit() {

    if (this.updateQuestionAnswerPopUp.valid) {
      let currentIndex = this.currentUpdateQuestionAnswer;
      if (typeof this.questionAnswers[currentIndex] != 'undefined') {
        this.questionAnswers[currentIndex].valueDescAr = this.updateQuestionAnswerPopUp.controls.valueDescAr.value;
        this.questionAnswers[currentIndex].valueDescEn = this.updateQuestionAnswerPopUp.controls.valueDescEn.value;
        this.questionAnswers[currentIndex].orderNo = this.updateQuestionAnswerPopUp.controls.orderNo.value;
        this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
        this.closeEditQuestionAnswerModel.nativeElement.click();
        this.updateQuestionAnswerPopUp.reset();
      } else {
        this.currentUpdateQuestionAnswer = null;
        this.toastrService.warning(this.translate.instant('QUESTION_ANSWER_NOT_EXIST'));
      }
    } else {
      this.toastrService.warning(this.translate.instant('PLEASE_ENTER_REQUIRE_FIEDLS'));
      this.updateQuestionAnswerPopUp.markAllAsTouched();
      this.updateQuestionAnswerPopUp.markAsDirty();
    }
  }

  deleteQuestionAnswer(index: number) {
    if (typeof this.questionAnswers[index] != 'undefined') {
      if (typeof this.questionAnswers[index].id != 'undefined') {
        // Answers to be delete
        this.deleteQuestionAnswersIds.push(this.questionAnswers[index].id)
      }
      this.questionAnswers.splice(index, 1);
      this.toastrService.success(this.translate.instant('DELETED_SUCCESSFULLY'));
    } else {
      this.toastrService.warning(this.translate.instant('QUESTION_ANSWER_NOT_EXIST'));
    }

  }

  updatingQuestionAnswerToBe(questionId: number) {
    if (this.questionAnswers.length > 0) {
      let answerCount = this.questionAnswers.length;
      this.questionAnswers.forEach((element: any, index: number) => {
        if (typeof element.id == 'undefined') {
          this.admService.addQuestionAnswer(this.orgid, questionId, element.valueDescAr, element.valueDescEn, element.orderNo)
            .subscribe(
              data => {
                if ((index + 1) == answerCount) {
                  if (this.deleteQuestionAnswersIds.length > 0) {
                    this.deleteQuestionAnswersFromBe();
                  } else {
                    this.router.navigate(['/admission/questions']);
                    this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
                    this.updating = false
                  }
                }
              },
              error => {

                this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_ANSWERS'));
              }
            );
        } else {
          this.admService.updateQuestionAnswer(element.id, this.orgid, questionId, element.valueDescAr, element.valueDescEn, element.orderNo)
            .subscribe(
              data => {
                if ((index + 1) == answerCount) {
                  if (this.deleteQuestionAnswersIds.length > 0) {
                    this.deleteQuestionAnswersFromBe();
                  } else {
                    this.router.navigate(['/admission/questions']);
                    this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
                    this.updating = false
                  }
                }
              },
              error => {

                this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_ANSWERS'));
              }
            );
        }
      });
    }
  }

  deleteQuestionAnswersFromBe() {
    if (this.deleteQuestionAnswersIds.length > 0) {
      let deleteQuestionAnswersCount = this.deleteQuestionAnswersIds.length;
      this.deleteQuestionAnswersIds.forEach((element: any, index: number) => {
        this.admService.deleteQuestionAnswer(element)
          .subscribe(
            data => {
              if ((index + 1) == deleteQuestionAnswersCount) {
                this.router.navigate(['/admission/questions']);
                this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
                this.updating = false
              }
            },
            error => {
              this.toastrService.warning(this.translate.instant('CAN_NOT_DELETE_ANSWERS'));
            }
          );
      });
    }
  }

}
